import { readSessionItem, resolveUtmSourceAndMedium } from "../utils/utmParams";

function writeSessionItem(key, value) {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(key, value);
  } catch {
    /* noop */
  }
}

/** Persiste UTM en sessionStorage lo antes posible en la carga (llamar desde index.js). */
export function saveUtmParams() {
  if (typeof window === "undefined") return;

  let params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch {
    params = new URLSearchParams();
  }

  const campaign = normalizeOptional(params.get("utm_campaign"));
  const term = normalizeOptional(params.get("utm_term"));
  if (campaign) writeSessionItem("utm_campaign", campaign);
  if (term) writeSessionItem("utm_term", term);

  const { utm_source, utm_medium } = resolveUtmSourceAndMedium();
  writeSessionItem("utm_source", utm_source);
  writeSessionItem("utm_medium", utm_medium);
}

function normalizeOptional(value) {
  if (value == null) return null;
  const t = String(value).trim();
  return t === "" ? null : t;
}

/**
 * UTM coherentes para leads / WhatsApp / Tecnóm.
 * Sin `window`, devuelve nulls como guardarraíl (SSR o tests).
 */
export function getUtmParams() {
  if (typeof window === "undefined") {
    return {
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
    };
  }

  let params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch {
    params = new URLSearchParams();
  }

  const { utm_source, utm_medium } = resolveUtmSourceAndMedium();

  const urlCampaign = normalizeOptional(params.get("utm_campaign"));
  const urlTerm = normalizeOptional(params.get("utm_term"));
  const utm_campaign = urlCampaign || readSessionItem("utm_campaign");
  const utm_term = urlTerm || readSessionItem("utm_term");

  return { utm_source, utm_medium, utm_campaign, utm_term };
}

/** URL actual con utm_source=CONSULTA WEB y utm_medium resuelto (sesión / URL / default). */
export function buildWhatsAppConsultaPageUrl() {
  const { utm_medium } = getUtmParams();
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set("utm_source", "CONSULTA WEB");
  currentUrl.searchParams.set("utm_medium", utm_medium || "");
  return currentUrl.toString();
}
